const subMenuList = [{
  // Learn 임시 주석처리 [2022.08.16]
  // learn : [
  //   { 'menu': 'learn', 'name': 'Code Lab', 'path': '/learn/code-lab', 'icon': 'icofont-light-bulb' },
  //   { 'name': 'Open Source', 'path': '/learn/open-source' }
  // ],
  develop : [
    { 'menu': 'develop', 'name': 'Testing APIs', 'path': '/develop/testing-apis', 'icon': 'icofont-spanner' },
    // { 'name': 'APIs Manual', 'path': '/develop/apis-manual' },
    // { 'name': 'Testing APIs', 'path': '/develop/testing-apis' }
  ], 
  design : [ 
    { 'menu': 'design', 'name': 'UI Components', 'path': '/design/ui-components', 'icon': 'icofont-paint' },
    { 'name': 'Development Guide', 'path': '/design/development-guide' }
  ], 
  support : [ 
    // { 'menu': 'support', 'name': 'Ask the Community', 'path': '/support/ask-the-community', 'icon': 'icofont-support' },
    { 'name': 'Developer Support', 'path': '/support/developer-support', 'icon': 'icofont-support' },
    { 'name': 'Frequently Asked Questions', 'path': '/support/frequently-asked-questions' },
  ], 
  connect : [ 
    { 'menu': 'connect', 'name': 'News', 'path': '/connect/news', 'icon': 'icofont-connection' },
    // Blog 임시 주석처리 [2022.07.25]
    // { 'name': 'Blog', 'path': '/connect/blog' }, 
    { 'name': 'Conference', 'path': '/connect/conference' }
  ],
  addition : [ 
    { 'menu': 'addition', 'name': 'Developer Employ', 'path': '/addition/developer-employ', 'icon': 'icofont-connection' },
    { 'name': 'Privacy Policy', 'path': '/addition/privacy-policy' },
    { 'name': 'Terms of service', 'path': '/addition/terms-of-service' },
  ],
}]

const menuList = [
  // Learn 임시 주석처리 [2022.08.16]
  // { menu: 'learn', icon: 'icofont-light-bulb' }, 
  { menu: 'develop', icon: 'icofont-spanner' },
  { menu: 'design', icon: 'icofont-paint' },
  { menu: 'support', icon: 'icofont-support' },
  { menu: 'connect', icon: 'icofont-connection' },
  { menu: 'addition', icon: 'icofont-connection' }
]

const menuList_2 = [
  // Learn 임시 주석처리 [2022.08.16]
  // { menu: 'learn', path: '/learn/code-lab', icon: 'icofont-light-bulb', color: 'theme_1'},
  // { menu: 'Code Lab', path: '/learn/code-lab', icon: 'icofont-light-bulb', color: 'theme_1' },
  // { menu: 'Open Source', path: '/learn/open-source', icon: 'icofont-light-bulb', color: 'theme_1' },

  { menu: 'develop', path: '/develop/access-token-management', icon: 'icofont-spanner', color: 'theme_1' },
  // { menu: 'Access Token Management', path: '/develop/access-token-management', icon: 'icofont-spanner', color: 'theme_2' },
  { menu: 'APIs Manual', path: '/develop/apis-manual', icon: 'icofont-spanner', color: 'theme_1' },
  { menu: 'Testing APIs', path: '/develop/testing-apis', icon: 'icofont-spanner', color: 'theme_1' },
  
  { menu: 'design', path: '/design/ui-components', icon: 'icofont-paint', color: 'theme_2' },
  { menu: 'UI Components', path: '/design/ui-components', icon: 'icofont-paint', color: 'theme_2' },
  { menu: 'Development Guide', path: '/design/development-guide', icon: 'icofont-paint', color: 'theme_2' },

  { menu: 'support', path: '/support/frequently-asked-questions', icon: 'icofont-support', color: 'theme_3' },
  { menu: 'Developer Support', path: '/support/developer-support', icon: 'icofont-support', color: 'theme_3' },
  { menu: 'Frequently Asked Questions', path: '/support/frequently-asked-questions', icon: 'icofont-support', color: 'theme_3' },

  { menu: 'connect', path: '/connect/news', icon: 'icofont-connection', color: 'theme_4' },
  { menu: 'News', path: '/connect/news', icon: 'icofont-connection', color: 'theme_4' },
  { menu: 'Conference', path: '/connect/conference', icon: 'icofont-connection', color: 'theme_4' },

  { menu: 'addition', path: '/addition/terms-of-service', icon: 'icofont-connection', color: 'theme_5' },
  { menu: 'Developer Employ', path: '/addition/developer-employ', icon: 'icofont-connection', color: 'theme_5' },
  { menu: 'Terms of service', path: '/addition/terms-of-service', icon: 'icofont-connection', color: 'theme_5' },
  { menu: 'Privacy Policy', path: '/addition/privacy-policy', icon: 'icofont-connection', color: 'theme_5' },

]

  module.exports = { subMenuList, menuList, menuList_2 }
  